import React from "react";
import CurrencyFormat from '../../Formatters/CurrencyFormat';

export default function AmericoCoverageAmounts(endAmount, startAmount) {

  const start = startAmount ? startAmount : 10000;
  const end = endAmount;
  const amounts = [];
  let increment = start < 100000 ? 10000 : 50000;

  for (let i = start; i <= end;) {
    increment = i < 100000 ? 10000 : 50000;
    if (i === start) {
      amounts.push({ label: <CurrencyFormat number={i} whole shortK />, value: i });
    } else if (i === end) {
      if (end < 1000000) {
        amounts.push({ label: <CurrencyFormat number={i} whole shortK />, value: i });
      } else {
        amounts.push({ label: <CurrencyFormat number={i} whole shortM />, value: i });
      }
    } else if(i + increment > end)
    {
      if (end < 1000000) {
        amounts.push({ label: '', value: i });
        amounts.push({ label: <CurrencyFormat number={end} whole shortK />, value: end });
      } else {
        amounts.push({ label: '', value: i });
        amounts.push({ label: <CurrencyFormat number={end} whole shortM />, value: end });
      }
    }
    else {
      amounts.push({ label: '', value: i });
    }
    
    i += increment;
  }

  return amounts;
}

export function getFaceAmountFromAge(age) {
  let coverageAmount = 500000;
  if (age >= 18 && age < 55) {
    coverageAmount = 500000;
  } else if (age >= 55) {
    coverageAmount = 300000;
  }
  return coverageAmount;
}
